/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { TriggerManualRunAodRulesMutationRequest, TriggerManualRunAodRulesMutationResponse, TriggerManualRunAodRulesPathParams } from "../models/TriggerManualRunAodRules";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { triggerManualRunAodRules } from "../axios/triggerManualRunAodRules";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const triggerManualRunAodRulesMutationKey = () => ["audit-reports-api", { url: '/aod-rules/:id/manual-run' }] as const

export type TriggerManualRunAodRulesMutationKey = ReturnType<typeof triggerManualRunAodRulesMutationKey>

export function triggerManualRunAodRulesMutationOptions<TContext = unknown>(config: Partial<RequestConfig<TriggerManualRunAodRulesMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = triggerManualRunAodRulesMutationKey()
        return mutationOptions<TriggerManualRunAodRulesMutationResponse, ResponseErrorConfig<Error>, {id: TriggerManualRunAodRulesPathParams["id"], data: TriggerManualRunAodRulesMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return triggerManualRunAodRules(id, data, config)
          },
        })

}

/**
 * @description Triggers a manual AOD run for a specific AOD rule
 * @summary Trigger a manual AOD run for an AOD rule
 * {@link /aod-rules/:id/manual-run}
 */
export function useTriggerManualRunAodRules<TContext>(options: 
{
  mutation?: UseMutationOptions<TriggerManualRunAodRulesMutationResponse, ResponseErrorConfig<Error>, {id: TriggerManualRunAodRulesPathParams["id"], data: TriggerManualRunAodRulesMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<TriggerManualRunAodRulesMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? triggerManualRunAodRulesMutationKey()

          const baseOptions = triggerManualRunAodRulesMutationOptions(config) as UseMutationOptions<TriggerManualRunAodRulesMutationResponse, ResponseErrorConfig<Error>, {id: TriggerManualRunAodRulesPathParams["id"], data: TriggerManualRunAodRulesMutationRequest}, TContext>
          

          return useMutation<TriggerManualRunAodRulesMutationResponse, ResponseErrorConfig<Error>, {id: TriggerManualRunAodRulesPathParams["id"], data: TriggerManualRunAodRulesMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<TriggerManualRunAodRulesMutationResponse, ResponseErrorConfig<Error>, {id: TriggerManualRunAodRulesPathParams["id"], data: TriggerManualRunAodRulesMutationRequest}, TContext>
      
}